import { searchBoxStyles } from "@insite/content-library/Widgets/Addresses/AddressBookSearchBox";
import Search from "@insite/mobius/Icons/Search";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import merge from "lodash/merge";
import { css } from "styled-components";

Object.assign(searchBoxStyles, {
    searchText: {
        iconProps: { 
            src: Search,
            css: css`
                position: absolute;
                box-sizing: border-box;
                top: 2px;
                right: 2px;
                width: 36px;
                height: 36px;
                padding: 8px;
                border-radius: 100%;
                pointer-events: none;
            `,
        },
        cssOverrides: {
            inputSelect: css`
                padding-right: 33px !important;
            `,
        },
    },
});
